import styled from 'styled-components';

const Divider = styled.div`
  border-top: 1px solid var(--color-border-tertiary);
`;

export default Divider;
